export function replaceCommas(value: number | string): string {
  let reg = value.toString()
  if (value.toString().includes(',')) reg = value.toString().replace(',', '.')
  return reg
}

export function isNumber(val: string): boolean {
  if (val === '') return false
  if (val.startsWith(',') || val.startsWith('.')) return false
  const reg = replaceCommas(val)
  return !isNaN(Number(reg))
}

export function isInteger(val: string): boolean {
  if (val === '') return false
  if (val.startsWith(',') || val.startsWith('.')) return false
  const reg = replaceCommas(val)
  return Number.isInteger(Number(reg))
}
